import { useIntl } from '@/intl'

import { space } from '@sunwebgroup/ui-components'

import { Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { css, type RuleSet, styled } from 'styled-components'

const Wrapper = styled.span<{ $disabled: boolean }>`
  display: block;
  margin-bottom: ${space('primitives_space_12')};

  ${Typography}:first-child {
    color: ${space('primitives_space_12')};
  }

  ${Typography}:last-child {
    white-space: nowrap;
  }

  ${({ $disabled }) => $disabled && modDisabled()}
`
function modDisabled(): RuleSet<object> {
  return css`
  ${Typography}:first-child,
  ${Typography}:last-child {
  }
`
}

export function RangeLabel({ disabled, formattedRange }: { disabled: boolean, formattedRange: string }) {
  const intl = useIntl()

  return (
    <Wrapper $disabled={disabled}>
      <Typography variant="body-s-regular-tight">{intl.formatMessage({ id: 'price_range_description' })}</Typography>
      {' '}
      <Typography variant="body-m-bold-tight">{formattedRange}</Typography>
    </Wrapper>
  )
}
